export default {
  discount_badge: '{{value}} de desconto',
  high_caffeine_warning_required: 'Alto teor de cafeína',
  pfand: 'Incl. {{value}} depósito',
  alcohol_by_volume_percent: '{{value}} % Vol. Álcool',
};
